<template>
  <v-app>
    <!-- LOADER GLOBAL -->
    <v-overlay :value="loading" attach="body" opacity="0.9">
      <v-progress-circular indeterminate size="64" color="primary" />
    </v-overlay>

    <router-view />
  </v-app>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState("ui", ["loading"]),
  },
};
</script>
